import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB-1IrlxhC4zD1i3ZR5wZCmK12nEnj1fBw",
  authDomain: "os-league.firebaseapp.com",
  projectId: "os-league",
  storageBucket: "os-league.firebasestorage.app",
  messagingSenderId: "617989649858",
  appId: "1:617989649858:web:ae043000e493e1a35f125b",
  measurementId: "G-NE2P623SLX",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
